import React from "react";
import { useTourPageContext } from "../../../_client/context";
import { useTripBuilder } from "../context/TripBuilderContext";
import { useI18n } from "@wojo/localization";
import { Contact } from "./Contact";
import { useMapDepartureStatus } from "../hooks/use-map-departure-status";
import { useShowMarketingMessageView } from "../context/use-show-marketing-message-view";

export const TripBuilderMessageViewCallToBook: React.FC = () => {
    const { productPage } = useI18n("productPage");
    const { callToBookDpd } = useTourPageContext();
    const { departure } = useTripBuilder();
    const departureStatus = useMapDepartureStatus(departure, callToBookDpd);
    const showMarketingMessageView = useShowMarketingMessageView();

    if (departureStatus !== "Call to book" || showMarketingMessageView) {
        return null;
    }
    return (
        <Contact
            formHeading={productPage.tripBuilder.contactUs.callToBook.formHeading.l()}
            formName="trip-builder-request"
            formDescription={productPage.tripBuilder.contactUs.callToBook.formDescription.l()}
            callHeading={productPage.tripBuilder.contactUs.callToBook.callHeading.l()}
            callDescription={productPage.tripBuilder.contactUs.callToBook.callDescription.l()}
        />
    );
};
